import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../reduxToolkit/store';
import {
  addReservation,
  removeReservation,
  addToShortlist,
  removeFromShortlist,
  initializeReservations,
  initializeShortlist,
  BookingStateItem,
} from '../reduxToolkit/reducers/bookingStateSlice';

export const useBookingState = () => {
  const dispatch = useDispatch();
  
  const reservations = useSelector((state: RootState) => state.bookingState.reservations);
  const shortlist = useSelector((state: RootState) => state.bookingState.shortlist);

  const isReserved = (roomId: number) => 
    reservations.some((item: BookingStateItem) => item.roomId === roomId);
  
  const isShortlisted = (roomId: number) => 
    shortlist.some((item: BookingStateItem) => item.roomId === roomId);

  const addRoomReservation = (bookingItem: BookingStateItem) => {
    dispatch(addReservation(bookingItem));
  };

  const removeRoomReservation = (roomId: number) => {
    dispatch(removeReservation(roomId));
  };

  const addRoomToShortlist = (bookingItem: BookingStateItem) => {
    dispatch(addToShortlist(bookingItem));
  };

  const removeRoomFromShortlist = (roomId: number) => {
    dispatch(removeFromShortlist(roomId));
  };

  const initializeReservationState = (reservations: BookingStateItem[]) => {
    dispatch(initializeReservations(reservations));
  };

  const initializeShortlistState = (shortlistItems: BookingStateItem[]) => {
    dispatch(initializeShortlist(shortlistItems));
  };

  const getRoomState = (roomId: number) => {
    const reserved = reservations.some((item: BookingStateItem) => item.roomId === roomId);
    const shortlisted = shortlist.some((item: BookingStateItem) => item.roomId === roomId);
    
    return {
      isReserved: reserved,
      isShortlisted: shortlisted,
      canReserve: !reserved,
      canShortlist: !reserved && !shortlisted,
    };
  };

  return {
    reservations,
    shortlist,
    isReserved,
    isShortlisted,
    addRoomReservation,
    removeRoomReservation,
    addRoomToShortlist,
    removeRoomFromShortlist,
    initializeReservationState,
    initializeShortlistState,
    getRoomState,
  };
};